"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var ButtonMenu_1 = require("./Controls/ButtonMenu/ButtonMenu");
var AcceptPreviewEventEmitter_1 = require("./Controls/AcceptPreviewEventEmitter");
var MountReactComponent_1 = __importDefault(require("@CommonFrontend/MountReactComponent/MountReactComponent"));
var react_1 = __importDefault(require("react"));
var ReactAcceptFlow_1 = require("./ReactAcceptFlow");
var AgreementComponent_1 = require("../Agreement/AgreementComponent");
var BlockPersister_1 = __importDefault(require("Project/BlockNew/BlockPersister"));
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var AcceptBlock = (function () {
    function AcceptBlock(project, block, make, modal, createUi, Editor, viewState, usingFeature, telemetry, projectStore, acceptPreviewEventEmitter, di, $timeout, QwilrStripe, account, apiBaseUrl, blockFetcher, projectTelemetry, blockCreator, deleteBlock, notifyUser, savedBlockService, $state, blockBuilder, projectLinkRetriever, rootDataStore) {
        var _this = this;
        this.childScope = undefined;
        var mainContent = make(Editor, {
            model: block.contentAreas.main,
            options: {},
            configuration: "standard",
        });
        var closeInlineForm = function () {
            _this.ui.showInlineForm = false;
        };
        var showPreview = function () { return __awaiter(_this, void 0, void 0, function () {
            var acceptBlockElement, incomingAgreementBlock, existingAgreementBlock;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!block.lock) return [3, 1];
                        acceptBlockElement = (_a = document.getElementsByClassName("project-block Accept")) === null || _a === void 0 ? void 0 : _a[0];
                        if (acceptBlockElement) {
                            (0, scroll_into_view_if_needed_1.default)(acceptBlockElement, {
                                scrollMode: "if-needed",
                                behavior: "smooth",
                                block: "start",
                            });
                        }
                        return [3, 5];
                    case 1:
                        if (!block.savedAgreement) return [3, 2];
                        return [2];
                    case 2:
                        if (!block.agreement) return [3, 4];
                        return [4, blockFetcher.fetchBlockById(project._id, block.agreement)];
                    case 3:
                        incomingAgreementBlock = _b.sent();
                        existingAgreementBlock = this.ui.agreementBlock;
                        if (!existingAgreementBlock) {
                            this.ui.agreementBlock = incomingAgreementBlock;
                        }
                        else if (incomingAgreementBlock.persistVersion > existingAgreementBlock.persistVersion) {
                            this.ui.agreementBlock = incomingAgreementBlock;
                        }
                        $timeout(function () {
                            _this.ui.showAgreementModal = true;
                        });
                        return [3, 5];
                    case 4:
                        telemetry.trackOnly("Accept Flow Previewed");
                        this.ui.showInlineToolbar = false;
                        this.ui.showInlineForm = true;
                        _b.label = 5;
                    case 5: return [2];
                }
            });
        }); };
        acceptPreviewEventEmitter.addListener(AcceptPreviewEventEmitter_1.AcceptPreviewEvent.OpenPreview, showPreview);
        acceptPreviewEventEmitter.addListener(AcceptPreviewEventEmitter_1.AcceptPreviewEvent.ClosePreview, closeInlineForm);
        this.ui = createUi(require("./Accept.html"), {
            block: block,
            viewState: viewState,
            mainContent: mainContent.ui,
            getAlignment: function () {
                return block.style != null ? block.style.acceptButton.alignment : undefined;
            },
            showInlineForm: false,
            showPreview: showPreview,
            acceptFlow: null,
            agreementModal: null,
            showAgreementModal: false,
            agreementBlock: null,
            $init: function ($scope) { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    $scope.$watch(function () {
                        return block.agreement;
                    }, function (agreement) { return __awaiter(_this, void 0, void 0, function () {
                        var _a, agreementBlockDi;
                        var _this = this;
                        var _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    if (!agreement) return [3, 2];
                                    _a = this.ui;
                                    return [4, blockFetcher.fetchBlockById(project._id, agreement)];
                                case 1:
                                    _a.agreementBlock = _c.sent();
                                    agreementBlockDi = blockBuilder({
                                        block: this.ui.agreementBlock,
                                        autoPersist: false,
                                        blockMenuActions: [],
                                    }).di;
                                    this.childScope = $scope.$new();
                                    make(BlockPersister_1.default, {
                                        options: {
                                            watchObject: "ui.agreementBlock",
                                            scope: this.childScope,
                                            apiRoute: "".concat(apiBaseUrl, "/projects/").concat(project._id, "/blocks/").concat(agreement),
                                            expectedSuccessMsg: "Block Updated",
                                            onPersisted: function () {
                                                return projectTelemetry.projectEdited(project);
                                            },
                                        },
                                        block: this.ui.agreementBlock,
                                    });
                                    this.ui.agreementModal = (0, MountReactComponent_1.default)(createUi, agreementBlockDi)(react_1.default.createElement(AgreementComponent_1.AgreementModalContainer, {
                                        di: agreementBlockDi,
                                        $scope: $scope,
                                        $timeout: $timeout,
                                        modalService: modal,
                                        usingFeature: usingFeature,
                                        acceptBlockSettings: block.settings,
                                        acceptBlock: block,
                                        project: project,
                                        isStripeIntegrationEnabled: account.integrations.stripe.enabled,
                                        stripePublicKey: QwilrStripe,
                                        telemetry: telemetry,
                                        onDismiss: function () {
                                            $timeout(function () { return (_this.ui.showAgreementModal = false); });
                                        },
                                        deleteBlock: deleteBlock,
                                        blockCreator: blockCreator,
                                        notifyUser: notifyUser,
                                        savedBlockService: savedBlockService,
                                        navigator: $state.go,
                                        pdfUrl: projectLinkRetriever.getPdfUrlForProject(projectStore),
                                        acceptPreviewEventEmitter: di.get("acceptPreviewEventEmitter"),
                                        rootDataStore: rootDataStore,
                                    }));
                                    return [3, 3];
                                case 2:
                                    (_b = this.childScope) === null || _b === void 0 ? void 0 : _b.$destroy();
                                    this.ui.agreementBlock = null;
                                    _c.label = 3;
                                case 3: return [2];
                            }
                        });
                    }); }, true);
                    $scope.$on("destroy", function () {
                        var _a;
                        (_a = _this.childScope) === null || _a === void 0 ? void 0 : _a.$destroy();
                    });
                    this.ui.acceptFlow = (0, MountReactComponent_1.default)(createUi, di)(react_1.default.createElement(ReactAcceptFlow_1.ReactAcceptFlowContainer, {
                        onClose: function () {
                            $timeout(closeInlineForm);
                        },
                        settings: block.settings,
                        $scope: $scope,
                        $timeout: $timeout,
                        isPreviewAccept: true,
                        account: account,
                        stripePublicKey: QwilrStripe,
                        projectId: project._id,
                        optOutSpringboard: usingFeature(FeatureFlag_1.default.OptOutSpringboardEngagementMenu),
                        telemetry: telemetry,
                        usingFeature: usingFeature,
                    }));
                    return [2];
                });
            }); },
            menuButton: function () {
                return make.invoke(ButtonMenu_1.mountButtonMenu, null, {
                    getAcceptLabel: function () { return block.settings.button.customLabel; },
                    setAcceptLabel: function (newLabel) { return (block.settings.button.customLabel = newLabel); },
                });
            },
            hasEditAccess: projectStore.isEditable,
            onAcceptButtonChange: function (newLabel) {
                return (block.settings.button.customLabel = newLabel);
            },
        });
    }
    return AcceptBlock;
}());
exports.default = AcceptBlock;
